<template>
  <div>
    <div class="pb-4">
      <PageHeader :title="'مدیریت دوره ' + (typeof pageTitle === 'string' ? pageTitle : '')" :items="pageHeaderItems" />
    </div>
    <TabLink :items="links">
      <div v-if="!$route.path.includes('faculty') && !$route.path.includes('support') && !$route.path.includes('agent') && model.status === 0">
        <b-button variant="primary" :class="{ disable: model.status !== 0 && model.status !== 2 }" class="ms-2" @click="sendRequest"> درخواست مجوز دوره</b-button>
      </div>

      <div v-else-if="!$route.path.includes('faculty') && !$route.path.includes('support') && !$route.path.includes('agent') && $route.params.courseId" class="d-flex">
        <b-button
          variant="danger"
          :class="{ disable: model.status === 3 || (model.status === 4 && addedUsers) }"
          class="px-4"
          @click="
            $bvModal.show('reject')
            model.licenseStatus = 3
          "
          >رد</b-button
        >
        <b-button
          variant="primary"
          class="ms-2"
          :class="{ disable: model.status === 2 }"
          @click="
            $bvModal.show('edit')
            model.licenseStatus = 2
          "
          >نیاز به اصلاح</b-button
        >
        <b-button
          variant="success"
          :class="{ disable: model.status === 4 }"
          class="px-5 ms-2"
          @click="
            model.licenseStatus = 4
            changeStaus()
          "
          >تایید</b-button
        >
      </div>
      <b-button v-else variant="primary" :class="{ disable: model.status !== 0 && model.status !== 2 }" class="ms-2" @click="sendRequest"> درخواست مجوز دوره</b-button>
    </TabLink>
    <div
      v-if="
        $route.fullPath !== '/list/skillupcourses/add' &&
        $route.fullPath !== '/list/facultyskillupcourses/add' &&
        $route.fullPath !== '/list/supportskillupcourses/add' &&
        $route.fullPath !== '/list/agentskillupcourses/add' &&
        !$route.params.courseId
      "
      class="card p-3"
    >
      برای اضافه کردن این بخش ابتدا باید دوره را ثبت نمایید
    </div>
    <div v-else-if="$route.path.includes('/users') && model.status != 4" class="card p-3">جهت مدیریت اعضا، ابتدا میبایست دوره تایید گردد.</div>
    <router-view v-else></router-view>
    <Toast :title="message" :error="error" :showToast="message !== ''" />
    <b-modal id="reject" no-close-on-esc hide-footer centered header-close-variant="dark" cancel-title>
      <template #modal-title> رد درخواست</template>
      <div>
        <TextAreaInput
          :value="model.description"
          @input="model.description = $event"
          title="علت رد درخواست"
          textAreaClass="align-items-center"
          titleStyle="align-self: baseline;"
          rows="10"
          :required="true"
          :showError="submit && !model.description"
          errortext="وارد کردن علت رد درخواست الزامی است."
        />
        <div class="pt-3 pb-0 d-flex flex-row justify-content-end">
          <b-button @click="$bvModal.hide('reject')">انصراف</b-button>
          <b-button variant="primary ms-2 px-5" @click="changeStaus">ثبت</b-button>
        </div>
      </div>
    </b-modal>
    <b-modal id="edit" no-close-on-esc hide-footer centered header-close-variant="dark" cancel-title>
      <template #modal-title>نیاز به اصلاح</template>
      <div>
        <TextAreaInput
          :value="model.description"
          @input="model.description = $event"
          title="علت نیاز به اصلاح"
          textAreaClass="align-items-center"
          titleStyle="align-self: baseline;"
          rows="10"
          :required="true"
          :showError="submit && !model.description"
          errortext="وارد کردن علت نیاز به اصلاح الزامی است."
        />
        <div class="pt-3 pb-0 d-flex flex-row justify-content-end">
          <b-button @click="$bvModal.hide('edit')">انصراف</b-button>
          <b-button variant="primary ms-2 px-5" @click="changeStaus">ثبت</b-button>
        </div>
      </div>
    </b-modal>
  </div>
</template>
<script>
import appConfig from '@/app.config'
import TextAreaInput from '../../../components/common/form/formModules/TextAreaInput.vue'
import TabLink from '../../../components/common/TabLink.vue'
import Toast from '../../../components/common/Toast.vue'
import PageHeader from '../../../components/layoutComponents/page-header.vue'
import listDataProvider from '../../../services/list'
import skillUpCourseProvider from '../../../services/skillUp/course'
import skillUpCourseSessionProvider from '../../../services/skillUp/healline'
import skillUpFrequentlyAskedQuestionsProvider from '../../../services/skillUp/question'
export default {
  page: {
    title: 'مدیریت دوره',
    meta: [
      {
        name: 'description',
        content: appConfig.description,
      },
    ],
  },
  name: 'skillUp-courses',
  components: {
    TabLink,
    PageHeader,
    TextAreaInput,
    Toast,
  },
  data() {
    return {
      pageHeaderItems: [
        { text: 'داشبورد', href: '/' },
        { text: 'مدیریت دوره', active: true },
      ],
      currentAvailableStatus: {},
      model: {
        productId: +this.$route.params.courseId,
        productType: 0,
        licenseStatus: 0,
        description: '',
      },
      error: false,
      message: '',
      addedHeadlines: false,
      addedQuestions: false,
      addedUsers: false,
      submit: false,
      pageTitle: '',
    }
  },
  watch: {
    '$route.path'() {
      this.fetchAvailableStatus()
      this.fetchCourseUsers()
    },
    '$route.query.usersUpdate'() {
      this.fetchCourseUsers()
    },
  },
  computed: {
    isFaculty() {
      return false
    },
    isAgent() {
      return this.$route.path.includes('agent')
    },
    links() {
      if (this.$route.params.courseId !== undefined) {
        return [
          {
            title: 'ثبت دوره',
            link:
              this.$route.params.courseId && this.$route.path.includes('faculty')
                ? `/list/facultyskillupcourses/detail/${this.$route.params.courseId}`
                : this.$route.params.courseId && this.$route.path.includes('support')
                ? `/list/supportskillupcourses/detail/${this.$route.params.courseId}`
                : this.$route.params.courseId && this.$route.path.includes('agent')
                ? `/list/agentskillupcourses/detail/${this.$route.params.courseId}`
                : this.$route.params.courseId && !this.$route.path.includes('faculty')
                ? `/list/skillupcourses/detail/${this.$route.params.courseId}`
                : this.$route.path.includes('faculty')
                ? '/list/facultyskillupcourses/add'
                : this.$route.path.includes('support')
                ? '/list/supportskillupcourses/add'
                : this.$route.path.includes('agent')
                ? '/list/agentskillupcourses/add'
                : '/list/skillupcourses/add',
            disable: this.isFaculty,
          },
          {
            title: 'سرفصل',
            link:
              this.$route.params.courseId && this.$route.path.includes('faculty')
                ? `/list/facultyskillupcourses/${this.$route.params.courseId}/headlines`
                : this.$route.params.courseId && this.$route.path.includes('support')
                ? `/list/supportskillupcourses/${this.$route.params.courseId}/headlines`
                : this.$route.params.courseId && this.$route.path.includes('agent')
                ? `/list/agentskillupcourses/${this.$route.params.courseId}/headlines`
                : this.$route.params.courseId && !this.$route.path.includes('faculty')
                ? `/list/skillupcourses/${this.$route.params.courseId}/headlines`
                : this.$route.path.includes('faculty')
                ? '/list/facultyskillupcourses/headlines'
                : this.$route.path.includes('support')
                ? '/list/supportskillupcourses/headlines'
                : this.$route.path.includes('agent')
                ? '/list/agentskillupcourses/headlines'
                : 'list/skillupcourses/headlines',

            disable: this.isFaculty,
          },
          {
            title: 'پیش نیاز',
            link:
              this.$route.params.courseId && this.$route.path.includes('faculty')
                ? `/list/facultyskillupcourses/${this.$route.params.courseId}/prerequisites`
                : this.$route.params.courseId && this.$route.path.includes('support')
                ? `/list/supportskillupcourses/${this.$route.params.courseId}/prerequisites`
                : this.$route.params.courseId && this.$route.path.includes('agent')
                ? undefined
                : this.$route.params.courseId && !this.$route.path.includes('faculty')
                ? `/list/skillupcourses/${this.$route.params.courseId}/prerequisites`
                : this.$route.path.includes('faculty')
                ? '/list/facultyskillupcourses/prerequisites'
                : this.$route.path.includes('support')
                ? '/list/supportskillupcourses/prerequisites'
                : this.$route.path.includes('agent')
                ? undefined
                : '/list/skillupcourses/prerequisites',
          },
          {
            title: 'سوالات متداول',
            link:
              this.$route.params.courseId && this.$route.path.includes('faculty')
                ? `/list/facultyskillupcourses/questions/${this.$route.params.courseId}`
                : this.$route.params.courseId && this.$route.path.includes('support')
                ? `/list/supportskillupcourses/questions/${this.$route.params.courseId}`
                : this.$route.params.courseId && this.$route.path.includes('agent')
                ? `/list/agentskillupcourses/questions/${this.$route.params.courseId}`
                : this.$route.params.courseId && !this.$route.path.includes('faculty')
                ? `/list/skillupcourses/questions/${this.$route.params.courseId}`
                : this.$route.path.includes('faculty')
                ? '/list/facultyskillupcourses/questions'
                : this.$route.path.includes('support')
                ? '/list/supportskillupcourses/questions'
                : this.$route.path.includes('agent')
                ? '/list/agentskillupcourses/questions'
                : '/list/skillupcourses/questions',
          },
          {
            title: 'اعضا',
            link:
              this.$route.params.courseId && this.$route.path.includes('faculty')
                ? `/list/facultyskillupcourses/${this.$route.params.courseId}/users`
                : this.$route.params.courseId && this.$route.path.includes('support')
                ? `/list/supportskillupcourses/${this.$route.params.courseId}/users`
                : this.$route.params.courseId && this.$route.path.includes('agent')
                ? undefined
                : this.$route.params.courseId && !this.$route.path.includes('faculty')
                ? `/list/skillupcourses/${this.$route.params.courseId}/users`
                : this.$route.path.includes('faculty')
                ? '/list/facultyskillupcourses/users'
                : this.$route.path.includes('support')
                ? '/list/supportskillupcourses/users'
                : this.$route.path.includes('agent')
                ? undefined
                : '/list/skillupcourses/users',
            disable: this.isFaculty,
          },
          {
            title: 'نظرات',
            link:
              this.$route.params.courseId && this.$route.path.includes('faculty')
                ? `/list/facultyskillupcourses/${this.$route.params.courseId}/coursecomments`
                : this.$route.params.courseId && this.$route.path.includes('support')
                ? `/list/supportskillupcourses/${this.$route.params.courseId}/coursecomments`
                : this.$route.params.courseId && this.$route.path.includes('agent')
                ? undefined
                : this.$route.params.courseId && !this.$route.path.includes('faculty')
                ? `/list/skillupcourses/${this.$route.params.courseId}/coursecomments`
                : this.$route.path.includes('faculty')
                ? `/list/facultyskillupcourses/coursecomments`
                : this.$route.path.includes('support')
                ? `/list/supportskillupcourses/coursecomments`
                : this.$route.path.includes('agent')
                ? undefined
                : `/list/skillupcourses/coursecomments`,
          },
          {
            title: 'دانش پذیران',
            link:
              this.$route.params.courseId && this.$route.path.includes('faculty')
                ? `/list/facultyskillupcourses/${this.$route.params.courseId}/courseadminstudents`
                : this.$route.params.courseId && this.$route.path.includes('support')
                ? `/list/supportskillupcourses/${this.$route.params.courseId}/courseadminstudents`
                : this.$route.params.courseId && this.$route.path.includes('agent')
                ? `/list/agentskillupcourses/${this.$route.params.courseId}/courseadminstudents`
                : this.$route.params.courseId && !this.$route.path.includes('faculty')
                ? `/list/skillupcourses/${this.$route.params.courseId}/courseadminstudents`
                : this.$route.path.includes('faculty')
                ? `/list/facultyskillupcourses/courseadminstudents`
                : this.$route.path.includes('support')
                ? `/list/supportskillupcourses/courseadminstudents`
                : this.$route.path.includes('agent')
                ? `/list/agentskillupcourses/courseadminstudents`
                : `/list/skillupcourses/courseadminstudents`,
          },
        ]
      }
      return [
        {
          title: 'ثبت دوره',
          link: this.$route.path.includes('faculty')
            ? '/list/facultyskillupcourses/add'
            : this.$route.path.includes('support')
            ? '/list/supportskillupcourses/add'
            : this.$route.path.includes('agent')
            ? '/list/agentskillupcourses/add'
            : '/list/skillupcourses/add',
        },
        { title: 'سرفصل', link: '#' },
        { title: 'پیش نیاز', link: this.$route.path.includes('agent') ? undefined : '#' },
        { title: 'سوالات متداول', link: '#' },
        { title: 'نظرات', link: this.$route.path.includes('agent') ? undefined : '#' },
        { title: 'اعضا', link: this.$route.path.includes('agent') ? undefined : '#' },
        { title: 'دانش پذیران', link: '#' },
      ]
    },
  },

  methods: {
    async sendRequest() {
      await this.checkAddedHeadlines()
      if (!this.addedHeadlines) return
      await this.checkAddedQuestion()
      if (!this.addedQuestions) return
      this.model.licenseStatus = 1
      this.changeStaus()
    },
    async fetchAvailableStatus() {
      if (this.$route.params.courseId) {
        const req = await skillUpCourseProvider.getAvailableStatus({
          productId: +this.$route.params.courseId,
          productType: 0,
        })
        if (req.status === 200) {
          this.model = req.data.data.output
          localStorage.setItem('productStatus', this.model.status)
          delete this.model.availableStatus
        }
      }
    },
    async checkAddedHeadlines() {
      const req = await skillUpCourseSessionProvider.getCourseSession(+this.$route.params.courseId)
      if (req.data && req.data.data.output.length) {
        this.addedHeadlines = true
      } else {
        this.error = true
        this.message = 'برای ارسال درخواست ابتدا باید سرفصل ها را اضافه نمایید'
        setTimeout(() => {
          this.error = false
          this.message = ''
        }, 5000)
      }
    },
    async checkAddedQuestion() {
      const req = await skillUpFrequentlyAskedQuestionsProvider.getQuestions(+this.$route.params.courseId)
      if (req.data && req.data.data.output.length) {
        this.addedQuestions = true
      } else {
        this.error = true
        this.message = 'برای ارسال درخواست باید حداقل یک سوال متداول اضافه نمایید'
        setTimeout(() => {
          this.error = false
          this.message = ''
        }, 5000)
      }
    },
    async changeStaus() {
      this.submit = true
      if ((this.model.licenseStatus == 2 || this.model.licenseStatus == 3) && !this.model.description) {
        return false
      }
      const req = await skillUpCourseProvider.updateAvailableStatus({
        productId: +this.$route.params.courseId,
        productType: 0,
        licenseStatus: +this.model.licenseStatus,
        description: this.model.description,
      })
      if (req?.data?.data?.isSuccessful) {
        this.message = 'وضعیت با موفقیت تغییر یافت.'
        this.$bvModal.hide('reject')
        this.$bvModal.hide('edit')
        this.fetchAvailableStatus()
        this.fetchCourseUsers()
        setTimeout(() => {
          this.message = ''
        }, 5000)
      } else {
        this.error = true
        this.message = 'خطایی رخ داده لطفا دوباره تلاش کنید.'
        this.$bvModal.hide('reject')
        this.$bvModal.hide('edit')
        setTimeout(() => {
          this.error = false
          this.message = ''
        }, 5000)
      }
    },
    async fetchCourseUsers() {
      const req = await listDataProvider.getListData({
        fieldSearchs: [
          {
            fieldName: 'CourseId',
            text: this.$route.params.courseId,
          },
        ],
        key: 'skillupcoursepeople',
      })
      if (req.data && req.data.data.rows.length) {
        this.addedUsers = true
      }
    },
  },
  mounted() {
    this.fetchAvailableStatus()
    this.fetchCourseUsers()
    setTimeout(() => {
      this.pageTitle = localStorage.getItem('entityTitle')
    }, 2000)
  },
}
</script>

<style lang="scss" scoped>
::v-deep .modal.show .modal-dialog {
  min-width: 611px !important;
  width: 611px !important;
}

// ::v-deep .modal-body {
//   min-height: 400px !important;
// }

.disable {
  background: #ced4da;
  pointer-events: none;
  border-color: #ced4da;
}
</style>
